import React, { memo, useState, useEffect } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import './index.scss';
import ReactDom from 'react-dom';
// import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  left__dialog: {
    position: 'fixed',
    zIndex: 999,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    overflow: 'auto',
    background: 'rgba(249, 250, 252, 0.6)',
    boxShadow: '0px 0px 40px rgba(38, 50, 56, 0.06);',
    backdropFilter: ' blur(30px)',
    display: 'none',
  },
  white_label__dialog: {
    width: '64%',
    height: 'calc(100vh - 9.5rem)',
    display: 'none',
    zIndex: 1999,
    overflow: 'auto',
    position: 'fixed',
    boxShadow: '0px 0px 40px rgba(38, 50, 56, 0.06)',
    backdropFilter: 'blur(10px)',
    borderRadius: '15px',
  },
  toggleDisplay: {
    display: 'block',
  },
  dialog__box__container: {
    overflowY: 'auto',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
  },
  white_label_dialog__box__container: {
    overflowY: 'auto',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    borderRadius: '15px',
    marginBottom: '1rem',
  },
  dialog__box: {
    background: '#f6f8fa',
    border: '2px solid #ffffff',
    boxSizing: 'border-box',
    boxShadow: '0px 0px 40px rgb(38, 50, 56, 0.06)',
    borderRadius: '15px',
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    // padding: '1.5rem',
  },
  single_dialog_dialog__box: {
    background: '#ffffff',
    border: '1px solid #DDE9FB',
    boxSizing: 'border-box',
    boxShadow: '0px 0px 40px rgb(38, 50, 56, 0.06)',
    borderRadius: '15px',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
  },
  popupp__heading: {
    fontSize: '20px',
    color: '#29264A',
    marginBottom: '30px',
    fontWeight: '600',
    lineHeight: '34px',
  },
  fields__container: {
    padding: '30px',
    maxHeight: '75vh',
    overflowY: 'auto',
  },
  action__btns: {
    fontSize: '13px',
    borderRadius: '100px !important',
    fontWeight: '500 !important',
    textTransform: 'none',
  },
  right__btn: {
    minWidth: '106px',
    color: '#fff !important',
    background: '#FF6019',
    marginLeft: '20px',
    padding: '0.5rem 1.2rem',
    '&:hover': {
      background: '#FF6019',
    },
  },
  save__btn: {
    color: '#6921C4',
  },
  close__appointment__btn: {
    background: '#fff',
    border: '1px solid #6921C4',
    padding: ' 0 1rem',
    color: '#6921C4',
    marginLeft: '1rem',
    '&:hover': {
      background: '#fff',
    },
  },
  back__btn: {
    fontSize: '13px',
    borderRadius: '100px',
    height: '38px',
    width: 'max-content',
    minWidth: 'max-content',
    fontWeight: '500',
    textTransform: 'capitalize',
    justifyContent: 'flex-start',
    color: 'rgba(109, 125, 139, 0.8)',
    transition: '0.3s',
    background: 'transparent',
    '&:hover': {
      background: 'transparent',
      color: 'rgb(45, 68, 87)',
    },
  },
  W40: {
    width: '40%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '98%',
    },
  },
  W50: {
    maxWidth: '50%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '98%',
    },
  },
  W60: {
    maxWidth: '60%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '98%',
    },
  },
  W75: {
    maxWidth: '75%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '95%',
    },
  },
  left__actions: {
    background: '#fff',
    boxShadow: '0 -12px 36px rgba(0, 0, 0, 0.04)',
    padding: '1rem 1.9rem',
    position: 'absolute',
    bottom: 0,
    left: 0,
  },
  btnDashed: {
    border: '1px dashed rgba(109, 125, 139, 0.5)',
    color: 'rgba(109, 125, 139, 0.5)',
    textTransform: 'capitalize',
    borderRadius: '15px',
    padding: '15px 20px',
  },
  // popup__open: {
  //   overflow: 'hidden',
  // },
  spinner: {
    marginLeft: '10px',
  },
  white__spinner: {
    color: '#fff',
  },
  disabled__btn: {
    color: 'rgba(0, 0, 0, 0.26) !important',
    background: 'rgba(0, 0, 0, 0.26)',
  },
}));

const SingleDialog = ({
  toggle,
  children,
  styles,
  whiteLabelPopUp,
  position,
}) => {
  const classes = useStyles();
  const [domReady, setDomReady] = useState(false);

  useEffect(() => {
    setDomReady(true);
  }, []);

  useEffect(() => {
    if (toggle) {
      document.body.classList.add('portal');
    } else {
      document.body.classList.remove('portal');
    }
  }, [toggle]);

  const dialogStyles = {
    top: `${position?.top}px`,
    left: `${position?.left}px`,
  };

  return domReady
    ? ReactDom.createPortal(
        <Grid
          xs={12}
          className={clsx(
            !whiteLabelPopUp
              ? classes.left__dialog
              : classes.white_label__dialog,
            toggle && classes.toggleDisplay,
          )}
          style={whiteLabelPopUp && dialogStyles}
        >
          <Grid
            container
            item
            xs={12}
            className={clsx(
              !whiteLabelPopUp
                ? classes.dialog__box__container
                : classes.white_label_dialog__box__container,
              styles,
            )}
          >
            <Grid
              className={
                !whiteLabelPopUp
                  ? classes.dialog__box
                  : classes.single_dialog_dialog__box
              }
            >
              {children}
            </Grid>
          </Grid>
        </Grid>,
        document.getElementById('portal'),
      )
    : null;
};
export default memo(SingleDialog);
